( function () {
   
    'use strict';
  
    ( function ( $ ) {
        $(".video-details .video-overlay-play a.video-play-icon").click(function () {
            if ($("#video").get(0).paused) {
                $("#video").trigger("play");
                $(".video-details .video-overlay-play a.video-play-icon").fadeOut(500);
                $(".video-play").addClass("open");
                $(".video-image").addClass("open");
                $(".video-overlay-play").addClass("open");
            
            } else {
                $("#video").trigger("pause");
                $(".video-details .video-overlay-play a.video-play-icon").fadeIn(500);
                $(".video-play").removeClass("open");
                $(".video-image").removeClass("open");
                $(".video-overlay-play").removeClass("open");
            }
        });
    } )( jQuery );
} )();